import { render, staticRenderFns } from "./news-details.vue?vue&type=template&id=3ecd055e&scoped=true&"
import script from "./news-details.vue?vue&type=script&lang=js&"
export * from "./news-details.vue?vue&type=script&lang=js&"
import style0 from "./news-details.vue?vue&type=style&index=0&id=3ecd055e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd055e",
  null
  
)

export default component.exports